import { render } from "./InputObjs.vue?vue&type=template&id=b48846a2&scoped=true"
import script from "./InputObjs.vue?vue&type=script&lang=js"
export * from "./InputObjs.vue?vue&type=script&lang=js"

import "./InputObjs.vue?vue&type=style&index=0&id=b48846a2&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b48846a2"]])

export default __exports__